import { render, staticRenderFns } from "./BedbuilderResetModal.vue?vue&type=template&id=517e09ea&scoped=true&"
import script from "./BedbuilderResetModal.vue?vue&type=script&lang=js&"
export * from "./BedbuilderResetModal.vue?vue&type=script&lang=js&"
import style0 from "./BedbuilderResetModal.vue?vue&type=style&index=0&id=517e09ea&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517e09ea",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIconCloseV2: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconCloseV2.vue').default,AppButton: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppButton.vue').default})
